import * as tslib_1 from "tslib";
import * as undoActions from 'owa-mail-undo';
import datapoints from '../datapoints';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import moveConversationService from 'owa-mail-store/lib/services/moveConversationService';
import moveMailListRowsHelper from './helpers/moveMailListRowsHelper';
import showNotificationOnMoveOrArchiveSucceeded from './helpers/showNotificationOnMoveOrArchiveSucceeded';
import { action } from 'satcheljs/lib/legacy';
import { actionNames } from 'owa-mail-store-actions';
import folderStore from 'owa-folders';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
import { getApplyConversationActionContext, getRowIdsFromRowKeys, } from 'owa-mail-list-store';
/**
 * The action worker which handles moving conversations.
 * @param rowKeys - the row keys of the rows that, need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the rows are moving from
 */
export default action('moveConversations', datapoints.moveConversationDatapoint)(function moveConversations(rowKeys, destinationFolderId, originalTableView, actionSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, moveMailListRowsHelper(rowKeys, destinationFolderId, originalTableView, moveConversationsInternal, actionSource)];
        });
    });
});
/**
 * The move conversations internal method
 * @param rowKeys - the row keys of the rows that need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the rows are moving from
 */
function moveConversationsInternal(rowKeys, destinationFolderId, originalTableView, sourceFolderId) {
    // Task 658: Reload client state when move conversation fails on the server.
    var conversationActionContexts = rowKeys.map(function (rowKey) {
        return getApplyConversationActionContext(rowKey, originalTableView.id);
    });
    var conversationIdStrings = getRowIdsFromRowKeys(rowKeys, originalTableView.id);
    raiseAction(actionNames.DeleteConversationStoreUpdate)(conversationIdStrings, originalTableView);
    // Make service request
    return (moveConversationService(conversationActionContexts, destinationFolderId, sourceFolderId)
        .then(function (response) {
        if (response.ResponseClass == 'Success') {
            undoActions.addActionToUndoStack(function () {
                return moveConversationService(conversationActionContexts, sourceFolderId, destinationFolderId);
            });
            var isArchiveFolder = destinationFolderId === getUserConfiguration().UserOptions.ArchiveFolderId;
            var destinationFolderName = folderStore.folderTable.get(destinationFolderId)
                .DisplayName;
            showNotificationOnMoveOrArchiveSucceeded(conversationActionContexts.length, destinationFolderName, isArchiveFolder);
        }
        else {
            // VSO 21472: Error handling for triage actions
        }
    })
        .catch());
}
//# sourceMappingURL=moveConversations.js.map